import { format, parseISO } from 'date-fns';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { SchedulingSlotDateTime } from '@/types/scheduling.type';

type TimeSlotGridProps = {
  slots: SchedulingSlotDateTime[];
  selectedSlot: string | undefined;
  onSlotSelect: (slot: SchedulingSlotDateTime) => void;
};

const formatTime = (isoString: string) => {
  const date = parseISO(isoString);
  return format(date, 'h:mmaaa').toLowerCase();
};

export function TimeSlotGrid({ slots, selectedSlot, onSlotSelect }: TimeSlotGridProps) {
  return (
    <div className="grid grid-cols-3 gap-2 pb-4 sm:grid-cols-4 md:grid-cols-5">
      {slots.map((slot) => {
        const formattedSlotTime = formatTime(slot.start);
        const isSelected = selectedSlot === slot.start;

        return (
          <Button
            type="button"
            key={slot.start}
            variant="outline"
            onClick={() => onSlotSelect(slot)}
            aria-label={`Select time slot ${formattedSlotTime}`}
            aria-pressed={isSelected}
            className={cn(
              'flex h-9 w-full items-center justify-center rounded-md border px-3 py-2 text-lg font-medium transition-all sm:px-3',
              'focus-visible:ring-hydrangea-500 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none',
              'text-main hover:bg-accent hover:border-hydrangea-300 border-[#DAE2F6] bg-white',
              isSelected &&
                'border-hydrangea-500 bg-hydrangea-50 text-hydrangea-500 hover:border-hydrangea-500 hover:bg-hydrangea-50 hover:text-hydrangea-500 shadow-sm'
            )}
          >
            {formattedSlotTime}
          </Button>
        );
      })}
    </div>
  );
}
